var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "backbone", "underscore", "client/resourceinfo"], function (require, exports, backbone_1, underscore_1, resourceinfo_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Themeable = void 0;
    exports.lookupStylingVarName = lookupStylingVarName;
    exports.serializeAsEntries = serializeAsEntries;
    exports.serializeStylingText = serializeStylingText;
    exports.serializeStylingForModule = serializeStylingForModule;
    exports.applyTheme = applyTheme;
    exports.enforcePrivateIcons = enforcePrivateIcons;
    backbone_1 = __importDefault(backbone_1);
    underscore_1 = __importDefault(underscore_1);
    resourceinfo_1 = __importDefault(resourceinfo_1);
    const THEME_SCHEMA = {
        "boxShadow": "",
        border: {
            width: {},
            color: {},
            style: {},
            radius: {},
            topLeftRadius: {},
            topRightRadius: {},
            bottomLeftRadius: {},
            bottomRightRadius: {}
        },
        colors: ["colors", {
                "primary": { "var": {} },
                "onPrimary": {},
                "onPrimaryFixed": {},
                "secondary": {},
                "onSecondary": {},
                "onSecondaryFixed": {},
                "tertiary": {},
                "onTertiary": {},
                "onTertiaryFixed": {},
                "outline": {},
                "outlineVariant": {},
                "surface": {},
                "onSurface": {},
                "surfaceComponent": {},
                "onSurfaceComponent": {},
                "surfaceContainer": {},
                "onSurfaceContainer": {},
                "onSurfaceContainerVariant": {},
                "titleText": {},
                "text": {},
                "textDisabled": {},
                "textAdditional": {},
                "textAdditionalVariant": {},
                "button": {},
                "buttonText": {},
                "buttonHover": {},
                "error": {},
                "onError": {},
                "errorContainer": {},
                "onErrorContainer": {},
            }],
        padding: {},
        margin: {},
        "typography.fontSize": ["font-size", {
                "sm": {},
                "base": {},
                "lg": {},
                "xl": {},
                "heading1": {},
                "heading2": {},
                "heading3": {},
                "heading4": {},
            }],
        "typography.fontWeight": ["font-weight", {
                "title": {},
                "fieldTitle": { deprecated: true }
            }],
        "typography.fontFamily": ["font-family", {
                "default": {},
                "heading": {},
                "code": {},
                "pre": {},
                "em": {},
                "quote": {},
            }],
        "borderWidth": {},
        "borderColor": {},
        "borderStyle": {},
        "borderRadius": {
            "default": {},
            "extra-small": {},
            "small": {},
            "medium-small": {},
            "standard": {},
            "large": {},
            "pill": {},
            "circle": {}
        },
        "spacing": {},
        "icons": ["icons", {
                "url": {},
                "height": {},
                "width": {},
            }],
    };
    function lookupStylingVarName(property, prefix) {
        prefix = prefix || "";
        const schema = THEME_SCHEMA;
        const path = property.split(".");
        let key = "";
        let schemaEntry = null;
        let i = 0;
        for (; i < path.length && schemaEntry == null; ++i) {
            key += path[i];
            if (key in schema) {
                // get the key in the schema.
                schemaEntry = schema[key];
                i++;
                break;
            }
            key += ".";
        }
        if (!schemaEntry) {
            return null;
        }
        if (i >= path.length) {
            return null;
        }
        let name = key;
        if (underscore_1.default.isArray(schemaEntry)) {
            name = schemaEntry[0];
            schemaEntry = schemaEntry[1];
        }
        var restOfKey = path.slice(i).join(".");
        if (!(restOfKey in schemaEntry)) {
            return null;
        }
        return "--" + (prefix ? `${prefix}-` : '') + dashForm(name) + "-" + dashForm(restOfKey);
    }
    const isAbsoluteUrl = function (url) {
        try {
            new URL(url);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    function theme2Vars(theme, prefix = "", themeDescriptor) {
        var _a, _b, _c, _d;
        // use THEME_SCHEMA
        const schema = THEME_SCHEMA;
        let result = {};
        for (const key of Object.keys(schema)) {
            const path = key.split(".");
            var obj = path.reduce((obj, pe) => {
                return obj == null ? obj : obj[pe];
            }, theme);
            if (key === "icons") {
                obj = (_a = themeDescriptor === null || themeDescriptor === void 0 ? void 0 : themeDescriptor.icons) !== null && _a !== void 0 ? _a : null;
                if (!obj) {
                    continue;
                }
            }
            else if (!obj) {
                continue;
            }
            if (key === "icons") {
                const iconsSection = schema[key];
                let iconsPrefix;
                let subSchema;
                if (underscore_1.default.isArray(iconsSection)) {
                    iconsPrefix = iconsSection[0];
                    subSchema = iconsSection[1];
                }
                else {
                    iconsPrefix = dashForm(key);
                    subSchema = iconsSection;
                }
                const iconsObj = obj;
                if (underscore_1.default.isObject(iconsObj)) {
                    const targetIcons = ["on-primary-logo", "primary-logo"];
                    const imgBasePath = ((_b = themeDescriptor === null || themeDescriptor === void 0 ? void 0 : themeDescriptor.resources) === null || _b === void 0 ? void 0 : _b.imgBasePath) || "../img/v2";
                    for (const iconName of targetIcons) {
                        const icon = iconsObj[iconName];
                        if (!underscore_1.default.isObject(icon))
                            continue;
                        const hasResourceLocation = "resourceLocation" in icon;
                        let urlAlreadySet = false;
                        for (const [propName, rawValue] of Object.entries(icon)) {
                            if (typeof rawValue !== "string" && typeof rawValue !== "boolean")
                                continue;
                            if (rawValue == null || (typeof rawValue === "string" && !rawValue.trim()))
                                continue;
                            let value = typeof rawValue === "boolean" ? rawValue.toString() : rawValue;
                            let mappedProp = propName;
                            if (propName === "resourceLocation" || propName === "imageBaseLocation") {
                                if (urlAlreadySet)
                                    continue;
                                if (propName === "resourceLocation") {
                                    let path = value;
                                    if (!isAbsoluteUrl(path)) {
                                        path = `${(_c = resourceinfo_1.default === null || resourceinfo_1.default === void 0 ? void 0 : resourceinfo_1.default.scriptLocation) !== null && _c !== void 0 ? _c : ""}../${path}`;
                                    }
                                    value = `url("${path}")`;
                                    urlAlreadySet = true;
                                }
                                else if (propName === "imageBaseLocation" && !hasResourceLocation) {
                                    let path = value;
                                    if (!isAbsoluteUrl(path)) {
                                        path = `${imgBasePath}/${path}`;
                                    }
                                    value = `url("${new URL(path, (_d = resourceinfo_1.default.scriptLocation) !== null && _d !== void 0 ? _d : "").href}")`;
                                    urlAlreadySet = true;
                                }
                                else {
                                    continue;
                                }
                                mappedProp = "url";
                            }
                            const dashIconName = iconName
                                .replace(/[^a-zA-Z0-9]/g, "-")
                                .toLowerCase();
                            const prefixPart = prefix ? prefix + "-" : "";
                            const dashProp = mappedProp
                                .replace(/[A-Z]/g, ch => "-" + ch.toLowerCase())
                                .toLowerCase();
                            const varName = `--${prefixPart}${iconsPrefix}-${dashIconName}-${dashProp}`;
                            result[varName] = value;
                        }
                    }
                }
            }
            var section = schema[key];
            var varPrefix = key;
            if (underscore_1.default.isArray(section)) {
                varPrefix = section[0];
                section = section[1];
            }
            else {
                varPrefix = dashForm(varPrefix);
            }
            if (typeof section === 'string') {
                const dashForm = varPrefix.replace(/[A-Z]/g, ch => "-" + ch.toLowerCase());
                const destVarName = `--${prefix ? prefix + "-" : ""}${dashForm}`;
                result[destVarName] = obj;
            }
            else if (typeof section === 'object' && section !== null) {
                for (const varName of Object.keys(section)) {
                    let value = "";
                    if (obj) {
                        if (typeof obj[varName] === "string") {
                            value = obj[varName];
                        }
                        else if (underscore_1.default.isObject(obj[varName])) {
                            const resolvedValue = Object.values(obj[varName]).reduce((acc, itemValue) => {
                                if (acc === null)
                                    return null;
                                const varResult = lookupStylingVarName(itemValue, prefix);
                                return varResult !== null && varResult !== void 0 ? varResult : null;
                            }, '');
                            if (!resolvedValue)
                                return null;
                            value = `var(${resolvedValue})`;
                        }
                    }
                    else {
                        value = null;
                    }
                    const dashForm = varName.replace(/[A-Z]/g, ch => "-" + ch.toLowerCase());
                    const destVarName = `--${prefix ? prefix + "-" : ""}${varPrefix}-${dashForm}`;
                    if (value) {
                        result[destVarName] = value;
                    }
                }
            }
        }
        return result;
    }
    const dashForm = (varName) => varName.replace(/[A-Z]/g, ch => "-" + ch.toLowerCase());
    function serializeAsEntries(key, entry, varLookup) {
        function renderEntry(entry) {
            if (typeof entry == "string") {
                return entry;
            }
            else if (typeof entry == "object") {
                const keys = Object.keys(entry);
                if (keys.length == 1 && keys[0] == "var") {
                    const varName = (entry["var"]);
                    const varResult = varLookup(varName);
                    if (!varResult) {
                        return null;
                    }
                    return `var(${varResult})`;
                }
            }
        }
        if (typeof entry === 'string') {
            return [`${dashForm(key)}: ${entry}`];
        }
        let prefix = "";
        // else if it is a typograpghy
        if (typeof entry != 'object') {
            return [];
        }
        const keys = Object.keys(entry);
        if (keys.length == 1 && keys[0] == "var") {
            // variable reference
            const varName = (entry["var"]);
            const mappedName = varLookup(varName);
            if (!mappedName) {
                console.log("Failed to resolve var ", varName);
                return [];
            }
            return [`${dashForm(key)}: var(${mappedName})`];
        }
        else if (key == "border") {
            prefix = "border-";
        }
        else if (key == "typography") {
            prefix = "";
        }
        return keys.map(key => {
            const value = entry[key];
            const renderedValue = renderEntry(value);
            if (renderedValue == null) {
                return null;
            }
            return `${prefix}${dashForm(key)}: ${renderedValue}`;
        }).filter(entry => entry != null);
    }
    function serializeStylingText(moduleStyling, prefix, varLookup) {
        let entries = [];
        for (const key of Object.keys(moduleStyling)) {
            const dashForm = key.replace(/[A-Z]/g, ch => "-" + ch.toLowerCase());
            const styling = moduleStyling[key];
            const stylingKeys = Object.keys(styling);
            const rules = underscore_1.default.flatten(stylingKeys.map((stylingKey) => serializeAsEntries(stylingKey, styling[stylingKey], varLookup)));
            if (prefix == null) {
                prefix = "";
            }
            else if (prefix.length > 0) {
                prefix += " ";
            }
            const ruleString = rules.join(";\n  ");
            entries.push(`${prefix}.${dashForm}
{
  ${ruleString};
}`);
        }
        return entries.join("\n\n");
    }
    function serializeStylingForModule(modules, typeName, name, varLookup) {
        const key = typeName + "." + name;
        if (!modules) {
            return null;
        }
        const moduleStyling = modules[key];
        if (!moduleStyling) {
            return null;
        }
        //TBD: This is wrong because we have 
        // The syling 
        // <div style="--mindbreeze-box-shadow: 0 2px 0 0 #266afd; --mindbreeze-border-width: 1px; --mindbreeze-border-color: #ddd; --mindbreeze-border-style: solid; --mindbreeze-colors-primary: #004178; --mindbreeze-colors-link: #004178; --mindbreeze-colors-link-hover: #004178; --mindbreeze-background-color-primary: #3788d8; --mindbreeze-background-color-surface-container: #f7f7f7;
        //
        // The resolved valiables for module stylings 
        //.card-border
        // {
        //   box-shadow: 1px 1px 4px 0px #6e6e6d;
        //   border-width: 0;
        //   border-color: #ccc;
        //   border-style: solid;
        //   border-radius: 0;
        //   background-color: var(--background-color-surface);
        // }
        //
        return serializeStylingText(moduleStyling, "", varLookup);
    }
    function applyTheme(themeEl, theme, prefix, useShadowRoot = false, themeDescriptor) {
        const varAssignment = theme2Vars(theme, prefix, themeDescriptor);
        if (!themeEl) {
            return;
        }
        let styleContainerDiv;
        if (themeEl.firstChild instanceof HTMLElement && useShadowRoot) {
            styleContainerDiv = document.createElement("style");
            themeEl.appendChild(styleContainerDiv);
        }
        let css = '';
        for (const varName of Object.keys(varAssignment)) {
            const value = varAssignment[varName];
            if (styleContainerDiv) {
                css += `${varName}: ${value};\n`;
            }
            else {
                themeEl.style.setProperty(varName, value);
            }
        }
        styleContainerDiv && (styleContainerDiv.textContent = `:host {\n${css}}`);
    }
    function selectTheme(themeDescriptor, selector) {
        if (!selector) {
            selector = "base";
        }
        const sel = selector;
        return themeDescriptor.themes[sel];
    }
    function enforcePrivateIcons(baseTheme, overrideTheme) {
        if (!(baseTheme === null || baseTheme === void 0 ? void 0 : baseTheme.icons) || !(overrideTheme === null || overrideTheme === void 0 ? void 0 : overrideTheme.icons)) {
            return;
        }
        for (let iconKey in baseTheme.icons) {
            if (baseTheme.icons[iconKey].private && overrideTheme.icons[iconKey]) {
                const _a = baseTheme.icons[iconKey], { ["private"]: _ } = _a, a = __rest(_a, ["private"]);
                const _b = overrideTheme.icons[iconKey], { ["private"]: __ } = _b, b = __rest(_b, ["private"]);
                // check if both icons are the same
                if (JSON.stringify(a) !== JSON.stringify(b)) {
                    delete overrideTheme.icons[iconKey];
                    console.warn(`Icon "${iconKey}" is private and cannot be overwritten by custom ThemeDescriptor`);
                }
            }
        }
    }
    /** Modes */
    class ModeListModel extends backbone_1.default.Model {
        currentModes() {
            return Object.keys(this.attributes).filter((key) => this.attributes[key] === true);
        }
    }
    class MediaBreakPoints {
        constructor(modeName, definition, nextBreakpointWidth, modeListModel) {
            this.modeName = modeName;
            this.modeListModel = modeListModel;
            this.nextBreakpointWidth = nextBreakpointWidth;
            const query = nextBreakpointWidth
                ? `(width >= ${definition}px) and (width < ${nextBreakpointWidth}px)`
                : `(width >= ${definition}px)`;
            this.mediaQueryList = window.matchMedia(query);
            this.mediaQueryList.addEventListener("change", () => this.onMediaQueryChange());
            //initialize the modes for first time
            this.onMediaQueryChange();
        }
        onMediaQueryChange() {
            this.modeListModel.set(this.modeName, this.mediaQueryList.matches);
        }
        destroy() {
            this.mediaQueryList.removeEventListener("change", () => this.onMediaQueryChange());
        }
    }
    class ModeSelector {
        constructor(modes) {
            this.modes = Array.isArray(modes) ? modes.filter(m => m.trim()) : modes.split(' ').filter(m => m.trim());
            // Sort modes by length ("dark", "xl")
            this.modes.sort((a, b) => b.length - a.length);
        }
        compareTo(other) {
            let cmp = this.modes.length - other.modes.length;
            if (cmp === 0) {
                cmp = other.modes.join(' ').length - this.modes.join(' ').length;
            }
            return cmp;
        }
        // Generates every possible mode combination. 
        // Example: given "xl" and "dark", the result will include [dark], [xl], and [dark xl]. 
        generateSubsets() {
            const { modes } = this;
            const subsets = [new ModeSelector([])];
            for (const mode of modes) {
                const current = subsets.map(sub => new ModeSelector([...sub.modes, mode]));
                subsets.push(...current);
            }
            return subsets;
        }
        getSortedSubsets() {
            return this.generateSubsets().sort((a, b) => a.compareTo(b));
        }
        mergeWithBase(name, widgets, deepMergeFn) {
            const sortedSubsets = this.getSortedSubsets();
            let result = Object.assign({}, widgets[name]);
            sortedSubsets.forEach((subset) => {
                if (subset.modes.length === 0)
                    return;
                const modeKey = `${name}[${subset.modes.join(' ')}]`;
                if (widgets[modeKey]) {
                    result = deepMergeFn(result, widgets[modeKey]);
                }
            });
            return result;
        }
    }
    class WidgetStylingProvider extends backbone_1.default.Model {
        constructor(attributes, modeListModel) {
            super(attributes);
            this.stylingModelMap = {};
            this.lastModes = [];
            this.modeListModel = modeListModel;
            this.modeListModel.on("change", () => this.updateWidgetStyles());
            this.updateWidgetStyles();
        }
        setThemeDescriptor(descriptor) {
            this.attributes = descriptor;
            this.updateWidgetStyles();
        }
        updateWidgetStyles() {
            const modes = this.modeListModel.currentModes();
            this.lastModes = modes;
            Object.entries(this.stylingModelMap).forEach(([name, model]) => {
                const newStyle = this.computeWidgetStyle(name);
                model.set(newStyle);
            });
        }
        deepMerge(target, source) {
            if (!source || typeof source !== 'object') {
                return target;
            }
            const output = Object.assign({}, target);
            for (const key of Object.keys(source)) {
                if (source[key] === undefined)
                    continue;
                if (source[key] && typeof source[key] === "object" && !Array.isArray(source[key])) {
                    output[key] = this.deepMerge(output[key] || {}, source[key]);
                }
                else if (Array.isArray(source[key]) && Array.isArray(output[key])) {
                    output[key] = [...output[key], ...source[key]];
                }
                else {
                    output[key] = source[key];
                }
            }
            return output;
        }
        getWidgetStyling(name) {
            var _a;
            const widgets = (_a = this.attributes) === null || _a === void 0 ? void 0 : _a.widgets;
            if (!(widgets === null || widgets === void 0 ? void 0 : widgets[name])) {
                console.warn(`no base style exist for: "${name}"`);
                return undefined;
            }
            if (!this.stylingModelMap[name]) {
                const style = this.computeWidgetStyle(name);
                this.stylingModelMap[name] = new backbone_1.default.Model(style);
            }
            return this.stylingModelMap[name];
        }
        computeWidgetStyle(name) {
            var _a;
            const modes = this.lastModes || [];
            const widgets = ((_a = this.attributes) === null || _a === void 0 ? void 0 : _a.widgets) || {};
            if (modes.length === 0) {
                return Object.assign({}, widgets[name] || {});
            }
            const selector = new ModeSelector(modes);
            return selector.mergeWithBase(name, widgets, this.deepMerge.bind(this));
        }
    }
    // is this actually a View?
    class Themeable extends backbone_1.default.View {
        constructor(options) {
            super(options);
        }
        initialize(options) {
            // this el is set.
            if (options.parent) {
                this.parent = options.parent;
            }
            this.mediaBreakpoints = [];
            this.modeListModel = new ModeListModel();
            this.selector = options.selector;
            this.baseThemeModel = new backbone_1.default.Model();
            this.model = new backbone_1.default.Model();
            this.prefix = options.prefix;
            this.useShadowRoot = options.useShadowRoot;
            this.listenTo(this.baseThemeModel, "change", this.applyTheme);
            if (options.themeDescriptor && !underscore_1.default.isEmpty(options.themeDescriptor)) {
                this.setThemeDescriptor(options.themeDescriptor);
            }
            this.setupBreakpoints();
            this.widgetStylingProvider = new WidgetStylingProvider(this.model.attributes, this.modeListModel);
        }
        setupBreakpoints() {
            this.mediaBreakpoints.forEach((bp) => bp.destroy());
            this.mediaBreakpoints = [];
            const breakpoints = this.model.get("breakpoints") || {};
            //sorting the breakpoints to create a range for mediaquery checks
            const sortedBreakpoints = Object.entries(breakpoints).sort((a, b) => a[1] - b[1]);
            for (let i = 0; i < sortedBreakpoints.length; i++) {
                const [modeName, width] = sortedBreakpoints[i];
                const nextWidth = i < sortedBreakpoints.length - 1 ? sortedBreakpoints[i + 1][1] : null;
                this.mediaBreakpoints.push(new MediaBreakPoints(modeName, width, nextWidth, this.modeListModel));
            }
        }
        applyTheme() {
            applyTheme(this.el, this.baseThemeModel.attributes, this.prefix, this.useShadowRoot, this.options.themeDescriptor);
        }
        importCustomFonts() {
            var _a, _b;
            const baseFonts = (_a = this.model.get("baseFonts")) !== null && _a !== void 0 ? _a : [];
            const fonts = (_b = this.model.get("fonts")) !== null && _b !== void 0 ? _b : [];
            const totalFonts = [
                ...baseFonts,
                ...fonts
            ].reduce((acc, font) => {
                acc.set(font.fontFamily, font);
                return acc;
            }, new Map());
            totalFonts.forEach(font => {
                const sources = Array.isArray(font.src) ? font.src : [font.src];
                const src = sources
                    .map(s => {
                    const parts = [];
                    if ('local' in s && s.local) {
                        parts.push(`local("${s.local}")`);
                    }
                    if ('url' in s && s.url) {
                        let fontUrl = s.url;
                        if (!isAbsoluteUrl(fontUrl)) {
                            // scriptLocation points to scripts
                            fontUrl = `${resourceinfo_1.default.scriptLocation}../${fontUrl}`;
                        }
                        const formatPart = s.format ? ` format("${s.format}")` : '';
                        parts.push(`url("${fontUrl}")${formatPart}`);
                    }
                    return parts.join(', ');
                })
                    .join(', ');
                const fontFace = new FontFace(font.fontFamily, src, {
                    weight: font.fontWeight,
                    style: font.fontStyle,
                });
                fontFace.load()
                    .then(loaded => {
                    document.fonts.add(loaded);
                })
                    .catch(err => console.error(`Failed to load font ${font.fontFamily}`, err));
            });
        }
        loadThemeCSS() {
            var _a;
            const cssFiles = (_a = this.options.themeDescriptor) === null || _a === void 0 ? void 0 : _a.css;
            if (!cssFiles || typeof cssFiles !== "object")
                return;
            Object.entries(cssFiles).forEach(([key, resource]) => {
                let href;
                if ("url" in resource) {
                    href = resource.url;
                }
                else {
                    href = resource.resourceLocation;
                    if (!isAbsoluteUrl(href)) {
                        href = `${resourceinfo_1.default.scriptLocation}../${href}`;
                    }
                }
                if (this.el.querySelector(`link[data-css="${key}"]`))
                    return;
                const link = document.createElement("link");
                link.rel = "stylesheet";
                link.href = href;
                link.dataset.css = key;
                this.el.appendChild(link);
            });
        }
        hasTheme() {
            return !underscore_1.default.isEmpty(this.model.attributes);
        }
        getStyleTextForModule(typeName, name) {
            const prefix = this.prefix || "";
            const varResolver = (name) => {
                return lookupStylingVarName(name, prefix);
            };
            if (!this.model.get("modules")) {
                return null;
            }
            return serializeStylingForModule(this.model.get("modules"), typeName, name, varResolver);
        }
        setThemeDescriptor(descriptor) {
            // propagate to children?
            const baseTheme = selectTheme(descriptor, this.selector);
            this.baseThemeModel.set(baseTheme || {});
            this.model.set(descriptor);
            this.importCustomFonts();
            this.loadThemeCSS();
            if (this.widgetStylingProvider) {
                this.widgetStylingProvider.setThemeDescriptor(descriptor);
            }
        }
        getWidgetStyling(name) {
            return this.widgetStylingProvider.getWidgetStyling(name);
        }
    }
    exports.Themeable = Themeable;
});
